import{__require as r}from"../Response.mjs";var e,n;function t(){if(n)return e;n=1;const t=r();return e={buildSmartyResponse:function(r,e){return r?new t(r.status,r.data,r.error,r.headers):new t(void 0,void 0,e)}}}export{t as __require};
